module.exports = __webpack_public_path__ + "img/levelup-top-shape.ca3d344b.svg";